<template>
  <div>
    <Table
      :no-data-text="$t('common.noData')"
      :columns="columns"
      :data="tableElasticBlockStoreResourceListData"
      style="width: 100.1%"
    ></Table>
    <!-- :page-size-opts="[2,4,6,8]" -->
    <Page
      :current="current"
      :total="dataTotal"
      show-sizer
      :page-size="pageSize"
      @on-change="changePage"
      @on-page-size-change="changeSize"
      :transfer="true"
    ></Page>
  </div>
</template>
<script>
var tableElasticBlockStoreResource = {};
export default {
  name: "TableElasticBlockStoreResource",
  data() {
    return {
      current: 1,
      dataTotal: 0,
      pageSize: 10,
      columns: [
        {
          title: this.$t("RAM.ALI.ElasticBlockStorage.accountName"),
          key: "accountName"
        },
        {
          title: this.$t("RAM.ALI.ElasticBlockStorage.accountID"),
          key: "accountIdString"
        },
        {
          title: this.$t("RAM.ALI.ElasticBlockStorage.cloudStorageName"),
          key: "name"
        },
        {
          title: this.$t("RAM.ALI.ElasticBlockStorage.cloudStorageID"),
          key: "volumeAwsId"
        },
        {
          title: this.$t("RAM.ALI.ElasticBlockStorage.cloudStorageCapacity"),
          key: "capacity"
        },
        {
          title: this.$t("RAM.ALI.ElasticBlockStorage.cloudStorageCategory"),
          key: "type"
        },
        {
          title: this.$t("RAM.ALI.ElasticBlockStorage.attachedStatus"),
          key: "stateName"
        },
        {
          title: this.$t("RAM.ALI.ElasticBlockStorage.attachedInstanceID"),
          key: "instanceId"
        },
        {
          title: "IOPS",
          key: "iops"
        }
      ],
      tableElasticBlockStoreResourceListData: []
    };
  },
  beforeCreate: function() {
    tableElasticBlockStoreResource = this;
  },
  created() {
    // 获取搜索内容
    eventBus.$on("companyId", function(val) {
      tableElasticBlockStoreResource.companyId = val;
    });
    eventBus.$on("accountName", function(val) {
      tableElasticBlockStoreResource.accountName = val;
    });
    eventBus.$on("cloudStorageName", function(val) {
      tableElasticBlockStoreResource.cloudStorageName = val;
    });
  },
  mounted: function() {},
  methods: {
    showAll: function() {
      tableElasticBlockStoreResource.getElasticBlockStoreResourceListData();
    },
    // 分页显示数据
    /****************************************************/
    getElasticBlockStoreResourceListData: function() {
      this.$api.resourceManagement
        .pagingQueryAliVolume({
          accountName: tableElasticBlockStoreResource.accountName,
          companyId: tableElasticBlockStoreResource.companyId,
          name: tableElasticBlockStoreResource.cloudStorageName,
          pageNum: this.current,
          pageSize: this.pageSize
        })
        .then(res => {
          this.tableElasticBlockStoreResourceListData = res.data.records;
          // 当前页
          this.current = res.data.current;
          // 总条数
          this.dataTotal = res.data.total;
        });
    },
    changePage: function(current) {
      this.current = current;
      tableElasticBlockStoreResourceVue.getElasticBlockStoreResourceListData();
    },
    changeSize: function(pageSize) {
      this.pageSize = pageSize;
      tableElasticBlockStoreResourceVue.getElasticBlockStoreResourceListData();
    }
  }
};
</script>
<style scoped>
.ivu-page {
  margin-top: 10px !important;
  margin-bottom: 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/ali/ebs/TableElasticBlockStoreResource.vue